import gsap from 'gsap';
import HomeHeader from './homeHeader';

export default class Loader {
    constructor() {
        this.duration = .85;
        this.timer = 2;

        this.logoOut();
    }

    logoOut() {
        gsap.to(
            document.querySelectorAll('.loader svg .loge polygon, .loader svg .loge path'),
            {
                yPercent: -150,
                opacity: 0,
                duration: this.duration,
                delay: this.timer,
                stagger: .1,
                onComplete: () => {
                    gsap.to(
                        document.querySelector('.loader'),
                        {
                            opacity: 0,
                            duration: .3,
                            onComplete: () => {
                                document.querySelector('.loader').style.display = 'none';
                            }
                        }
                    );
                    new HomeHeader();
                }
            }
        );

        gsap.to(
            document.querySelector('.loader svg .biarritz'),
            {
                opacity: 0,
                ease: 'power4.out',
                duration: .5,
                delay: this.timer
            }
        );
    }
}